import React from "react";
import { useNavigate } from "react-router-dom";
import { VERTICAL_LIST } from "../lib/verticals";

// Compact chip row that surfaces the vertical hubs (Imóveis/Médicos/Veículos)
// on mobile — where the sidebar is hidden.
export default function VerticalShortcuts() {
  const navigate = useNavigate();
  return (
    <div className="flex gap-2 overflow-x-auto scrollbar-hide -mx-1 px-1" data-testid="vertical-shortcuts">
      {VERTICAL_LIST.map((v) => (
        <button
          key={v.key}
          data-testid={`vertical-shortcut-${v.key}`}
          onClick={() => navigate(v.listRoute)}
          className="shrink-0 flex items-center gap-2 px-4 py-2.5 rounded-2xl bg-card border border-border hover:border-primary/60 hover:-translate-y-0.5 transition-all active:scale-95"
        >
          <span className="w-8 h-8 rounded-xl flex items-center justify-center" style={{ background: v.color }}>
            <v.icon className="w-4 h-4 text-white" />
          </span>
          <span className="text-sm font-semibold">{v.label}</span>
        </button>
      ))}
    </div>
  );
}
